// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class AlgorithmSubscribeMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_ALGORITHM_SUBSCRIBE_MESSAGE, fieldSet);
    }
    setAlgorithmId(algorithmId) {
        this.setFieldValue(FieldsFactory.FIELD_ALGORITHM_ID, algorithmId);
    }
    getAlgorithmId() {
        return this.getFieldValue(FieldsFactory.FIELD_ALGORITHM_ID);
    }
    setSubscribeAction(action) {
        this.setFieldValue(FieldsFactory.FIELD_SUBSCRIPTION_ACTION, action);
    }
    getSubscribeAction() {
        return this.getFieldValue(FieldsFactory.FIELD_SUBSCRIPTION_ACTION);
    }
}
